// extracted by css-extract-rspack-plugin
export default {"variationIcon":"PQziE"};